// Configuration object for search page events
export const searchPageEventsConfig = {
    parentSelector: '.template-search', // Parent scope for search page
    events: {
        // Search Bar Input Field on Search Page
        searchBarField: {
            selector: '.template-search__search .search__input',
            events: {
                click: {
                    event: 'search',
                    component: 'search_bar',
                    element: 'text_field',
                    action: 'click',
                    trigger: 'click'
                },
                input: {
                    event: 'search',
                    component: 'search_bar',
                    element: 'text_field',
                    action: 'input',
                    trigger: 'input',
                    getDynamicData: (element) => ({
                        action_value: element.value
                    })
                },
                submit: { // Submit via Enter key
                    event: 'search',
                    component: 'search_bar',
                    element: 'text_field',
                    action: 'submit',
                    trigger: 'submit',
                    getDynamicData: (element) => ({
                        action_value: element.value,
                        link_url: `/search?q=${encodeURIComponent(element.value)}`
                    })
                }
            }
        },
        // Clear Icon Click on Search Page Bar
        searchBarClear: {
            selector: '.template-search__search .reset__button svg.icon.icon-close',
            event: {
                event: 'search',
                component: 'search_bar',
                element: 'icon',
                action: 'click',
                trigger: 'click',
                getDynamicData: () => ({
                    action_value: 'remove'
                })
            }
        },
        // Search Icon Click on Search Page Bar
        searchBarIconClick: {
            selector: '.template-search__search button.search__button svg.icon.icon-search',
            event: {
                event: 'search',
                component: 'search_bar',
                element: 'icon',
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => {
                    const inputElement = element.closest('.search')?.querySelector('.search__input');
                    const searchTerm = inputElement ? inputElement.value : '';
                    return {
                        action_value: searchTerm,
                        link_url: `/search?q=${encodeURIComponent(searchTerm)}`
                    };
                }
            }
        },
        // Click on Predictive Search Results Links on Search Page
        searchPageResultsClick: {
            // Selector targets links (or their children) within the predictive search container on the search page
            selector: '.template-search__search .predictive-search a.predictive-search__item, .template-search__search .predictive-search a.predictive-search__item *',
            event: {
                event: 'search',
                component: 'search_bar', // Component is the search bar context
                element: 'link',
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => {
                    // Always find the parent anchor tag
                    const anchorElement = element.closest('a.predictive-search__item');
                    if (!anchorElement) return null; 
                    
                    let fieldName = 'link'; // Default field name
                    const parentList = anchorElement.closest('ul.predictive-search__results-list');
                    
                    // Determine field name based on the parent list ID
                    if (parentList && parentList.id) {
                        if (parentList.id.includes('-queries-list')) {
                            if (anchorElement.href.includes('/collections/')) {
                                fieldName = 'collections';
                            } else {
                                fieldName = 'suggestions';
                            }
                        } else if (parentList.id.includes('-products-list')) {
                            fieldName = 'products';
                        } else if (parentList.id.includes('-pages-list')) {
                            fieldName = 'pages';
                        }
                    }
                    
                    // Extract text content from the heading within the anchor
                    const contentElement = anchorElement.querySelector('.predictive-search__item-heading');
                    const linkText = contentElement ? contentElement.textContent.trim() : anchorElement.textContent.trim();

                    return {
                        field_name: fieldName,
                        link_text: linkText,
                        link_url: anchorElement.href
                    };
                }
            }
        }
        // Note: Predictive search results on the search page might need separate handling 
        // if their structure differs significantly from the header's.
    }
}; 